import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { getFormattedStartEndYearsForCalendar } from "@examspark/common";
import { Toolbar } from "@examspark/common-ui";
import { AcademicCalendar, CourseCalendar } from "@examspark/types";

const StyledCalendarLabel = styled(Toolbar)`
  padding: 1rem;
  border-bottom: solid 1px #ddd;
  color: #444;
  font-size: 1.1rem;

  svg {
    fill: #666;
    display: block;
  }

  a {
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
`;

const ActiveCalendarYears = styled.div`
  color: #777;
`;

const SidebarCalendarLabel = (props: {
  calendar: AcademicCalendar;
  to?: string;
}) => {
  const calendarFormattedYears = getFormattedStartEndYearsForCalendar(
    props.calendar,
  );

  return (
    <StyledCalendarLabel>
      <div>
        {props.to ? (
          <Link to={props.to}>
            {props.calendar?.name ?? "Untitled Calendar"}
          </Link>
        ) : (
          <>{props.calendar?.name ?? "Untitled Calendar"}</>
        )}
      </div>
      <div style={{ flex: 1 }}></div>
      <ActiveCalendarYears>{calendarFormattedYears}</ActiveCalendarYears>
    </StyledCalendarLabel>
  );
};

export const SidebarCourseCalendarLabel = (props: {
  calendar?: CourseCalendar;
  to?: string;
}) => {
  const calendarFormattedYears = getFormattedStartEndYearsForCalendar(
    props.calendar?.calendar,
  );

  return (
    <StyledCalendarLabel>
      <div>
        {props.to ? (
          <Link to={props.to}>
            {props.calendar?.name ?? "Untitled Calendar"}
          </Link>
        ) : (
          <>{props.calendar?.name ?? "Untitled Calendar"}</>
        )}
      </div>
      <div style={{ flex: 1 }}></div>
      <ActiveCalendarYears>{calendarFormattedYears}</ActiveCalendarYears>
    </StyledCalendarLabel>
  );
};

export default SidebarCalendarLabel;
